import type { Participant } from '@seen/core/models/patients/participant'
import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export const useDisenrollDialogStore = create(
  devtools(
    combine(
      {
        isOpen: false,
        participant: null as Participant | null,
      },
      (set) => ({
        open: (participant: Participant) =>
          requestAnimationFrame(() => {
            set({ isOpen: true, participant })
          }),
        close: () => set({ isOpen: false, participant: null }),
      })
    )
  )
)
